import { render, staticRenderFns } from "./profile-change-address.vue?vue&type=template&id=36fe6192&"
import script from "./profile-change-address.vue?vue&type=script&lang=js&"
export * from "./profile-change-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports